export default "__VITE_ASSET__awaAls2H__"